import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import get from 'lodash/get';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withNamespaces } from 'react-i18next';
import SharedSimilarSearchContent from '../../../components/organism/SharedSimilarSearchContent/SharedSimilarSearchContent';
import { getRequestBody, getProcessedProps } from './preProcessData';
import { isExperienceEditorActive } from '@sitecore-jss/sitecore-jss';
import withErrorBoundary from '../../../utils/HOCs/withErrorBoundary';
import Box from '../../../components/molecules/Box';
import { pageContentType } from '../../../utils/getContentType';
import { COMPONENT_NAME } from './locators';
import useStyles from './style';
import {
  getPageName,
  getComponentName,
} from '../../../utils/getPageComponentInfo';

const SimilarSearch = props => {
  const {
    getOtherBranchesStart,
    getMoreLikeThisStart,
    otherBranchesData,
    moreLikeThisData,
  } = props;
  const { title, ctaLink } = get(props, 'fields', '');
  const { params } = props || {};
  const variation =
    (get(params, 'variation.length') > 0 && params.variation) || 'MoreLikeThis';
  const classes = useStyles(props);
  let isEditor;
  const [hasFavouriteBasket, setHasFavouriteBasket] = useState(false);

  const previewMode =
    props &&
    props.sitecoreContext &&
    props.sitecoreContext.pageState &&
    props.sitecoreContext.pageState.toLowerCase();

  if (isExperienceEditorActive() || previewMode === 'preview') {
    isEditor = true;
  } else {
    isEditor = false;
  }

  const placeholders = get(props.sitecoreContext, 'VAAStaticRoute.sitecore.route.placeholders', '');
  const vadHeader = get(placeholders, 'vad-header', []);

  useEffect(() => {
    const favouriteBasket = vadHeader.find(item => item.componentName === 'FavoriteBasket');
    const favIsActive = get(favouriteBasket, 'fields["Is Active"].value', false);
    setHasFavouriteBasket(Boolean(favouriteBasket) && favIsActive)
  }, [vadHeader])

  useEffect(() => {
    if (get(props, 'sitecoreContext.language', false)) {
      if (variation === 'MoreLikeThis') {
        getMoreLikeThisStart(getRequestBody(props, variation, isEditor));
      } else if (variation === 'Branches') {
        getOtherBranchesStart(getRequestBody(props, variation, isEditor));
      }
    }
  }, [get(props, 'sitecoreContext.language', false)]);
  let expectedProps = getProcessedProps(
    props,
    variation === 'MoreLikeThis' ? moreLikeThisData : otherBranchesData
  );
  expectedProps = {
    ...expectedProps,
    fields: {
      ...expectedProps.fields,
      title,
      ctaLink,
      description: { value: get(ctaLink, 'value.text', '') },
      variation,
      pageContentType: pageContentType(props)?.toLowerCase(),
      pageName: getPageName(props),
      componentName: getComponentName(props),
      aspectRatioNeeded: true,
      appConfig: props.appConfig,
    },
  };
  // This will return cardItems array
  const isCardAvailable = get(expectedProps, 'fields.cardList', []);
  // If there is no cardItem avaialble then component will not render anything
  return isCardAvailable && isCardAvailable.length > 0 ? (
    <Box className={clsx(classes.root, 'withBg')} data-locator={COMPONENT_NAME}>
      {params?.backgroundColor && <div className='infographicsbgImage-moreLikethis'></div>}
      <SharedSimilarSearchContent {...expectedProps} hasFavouriteBasket={hasFavouriteBasket} />
    </Box>
  ) : null;
};

export default withErrorBoundary(
  withSitecoreContext()(withNamespaces()(SimilarSearch))
);
